import apiClient from './apiClient';

export const authService = {
  login: (email, password) => {
    return apiClient.post('/auth/login', { email, password });
  },

  signup: (email, username, password) => {
    return apiClient.post('/auth/signup', { email, username, password });
  },

  refreshToken: () => {
    return apiClient.post('/auth/refresh');
  },

  verifyToken: (token) => {
    return apiClient.get('/auth/verify', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};
